import * as React from 'react';
import { ContainerContext, mapProps } from './index';
import {
    BaseContainer,
    BaseElement,
    CreateSeasonLeaderBoardComponent,
    CreateSeasonRegularComponent,
} from '../components';
import actions from '../actions';
import { connect } from 'react-redux';
import { BarChartOutlined, EventOutlined, GamesOutlined as GamesIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { LeaderBoardType, SeasonType } from '../enums';
import { StateMap } from '../reducers';
import { Card, CardActionArea, CardContent, Grid2 as Grid } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props extends ContainerContext.Props {
}

interface State {
    seasonType: SeasonType | null;
}

class Container extends BaseElement<Props> {
    state: State = {
        seasonType: null,
    }

    protected renderContainer(): React.JSX.Element {
        const headlines = [
            {
                text: 'Season',
                to: `/season/all`,
            },
            {
                text: 'Create',
            },
        ];

        return (
            <BaseContainer
                {...this.props}
                styled={this.props.styled}
                title = {"Create Season"}
                TitleIcon = {GamesIcon}
                headlines = {headlines}
            >
                {this.renderContent()}
            </BaseContainer>
        );
    }

    private renderContent = () => {
        const { seasonType } = this.state;
        if (seasonType === null) {
            return (
                <Grid container={true} spacing={3} style={{ width: '90%', margin: 'auto' }}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Card>
                            <CardActionArea onClick={this.onSelectRegular} style={{ height: 126 }}>
                                <CardContent style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <EventOutlined style={{width: 36, height: 36, marginBottom: 10}}/>
                                    Regular Live Event
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Card>
                            <CardActionArea onClick={this.onSelectLeaderBoard} style={{ height: 126 }}>
                                <CardContent style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <BarChartOutlined style={{width: 36, height: 36, marginBottom: 10}}/>
                                    Leaderboard Live Event
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
            )
        }

        switch (seasonType) {
            case SeasonType.Regular:
                return (
                    <CreateSeasonRegularComponent
                        styled={this.props.styled}
                        type='Create'
                        onCreate={this.onCreateRegular}
                    />
                );
            case SeasonType.LeaderBoard:
                return (
                    <CreateSeasonLeaderBoardComponent
                        styled={this.props.styled}
                        type='Create'
                        onCreate={this.onCreateLeaderBoard}
                    />
                );
        }
    }

    private onSelectRegular = () => this.setState({ seasonType: SeasonType.Regular });
    private onSelectLeaderBoard = () => this.setState({ seasonType: SeasonType.LeaderBoard });

    private onCreateRegular = async (name: string, start: number, end: number, metadata: string, developerOnly: boolean, tiers: Entities.SeasonTier[], maxAmountPerReport: number) => {
        await actions.season.createRegular(name, start, end, metadata, developerOnly, tiers, maxAmountPerReport);
        this.toSeason();
    };

    private onCreateLeaderBoard = async (name: string, start: number, end: number, metadata: string, developerOnly: boolean, tiers: Entities.SeasonTier[], ranks: Entities.EntityLeaderBoardRank[], maxUsersPerInstance: number, maxAmountPerReport: number, leaderBoardType: LeaderBoardType) => {
        await actions.season.createLeaderBoard(name, start, end, metadata, developerOnly, tiers, ranks, maxUsersPerInstance, maxAmountPerReport, leaderBoardType);
        this.toSeason();
    };

    private toSeason = () => this.toLink( `/season/all`);
}

const mapStateToProps = (state: StateMap): Props => ({
    ...mapProps(state),
});
const AppContainer = (props: Props) =>
{
    const smallUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    return (<Container {...props} styled={{themeMode: props.app.themeMode, smallUp}} navigate={navigate}/>);
};
export default connect(mapStateToProps)(AppContainer);
